import axios from 'axios'
import localforage from 'localforage'
import { setupCache } from 'axios-cache-adapter'

const store = localforage.createInstance({
  driver: [
    localforage.INDEXEDDB
  ],
  name: 'atlas-cache'
})

const cache = setupCache({
  store,
  maxAge: 15 * 60 * 1000
})

const instance = (isCacheable = true, headers = {}) => {
  const config = {
    baseURL: '/api',
    headers
  }

  if (isCacheable) {
    config.adapter = cache.adapter
  }

  return axios.create(config)
}

export default instance



// WEBPACK FOOTER //
// ./src/services/Request/Request.js